[<template>
  <div>
    <el-table :data="opportunities.data" class="w100" stripe>
      <el-table-column label="Title" prop="title"></el-table-column>
      <el-table-column label="Description" prop="quote"></el-table-column>
      <el-table-column label="Button link" prop="post_link"></el-table-column>
      <el-table-column label="Position" prop="position"></el-table-column>
      <el-table-column label="Actions" align="right" width="200%">
        <template slot-scope="props">
          <el-tooltip
            content="Publish"
            placement="top"
            v-if="props.row.publish_time == null"
          >
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-top"
              @click="publishAH(props.row.id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            content="Unpublish"
            placement="top"
            v-if="props.row.publish_time !== null"
          >
            <el-button
              type="danger"
              circle
              size="small"
              icon="el-icon-bottom"
              @click="unpublishAH(props.row.id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Edit" placement="top">
            <el-button
              type="warning"
              circle
              size="small"
              icon="el-icon-edit"
              @click="openEdit(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Delete" placement="top">
            <el-button
              type="danger"
              circle
              size="small"
              icon="el-icon-close"
              @click="deleteAH(props.row.id)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('opportunityCarousel', ['opportunities'])
  },

  methods: {
    ...mapActions('opportunityCarousel', [
      'read',
      'delete',
      'publish',
      'unpublish'
    ]),
    ...mapMutations('opportunityCarousel', ['setDialog', 'setSelectedOpportunity']),

    openEdit(oppurtunity) {
      this.setDialog(true)
      this.setSelectedOpportunity(oppurtunity)
    },
    deleteAH(id) {
      this.$confirm('You will permanently delete this. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.delete(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    },
    publishAH(id) {
      this.$confirm('You will publish this. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.publish(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Publish cancelled'
          })
        })
    },
    unpublishAH(id) {
      this.$confirm('You will unpublish this. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.unpublish(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Unpublish cancelled'
          })
        })
    }
  },

  created() {
    this.read()
  }
}
</script>
